module.exports = __webpack_public_path__ + "img/Ethan_Headshot-photoaidcom-cropped.5510decd.JPG";